var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73287 0.583603C5.66305 0.198309 6.66001 0 7.66684 0C8.67366 0 9.67063 0.198309 10.6008 0.583603C11.531 0.968898 12.3762 1.53363 13.0881 2.24556C13.8 2.9575 14.3648 3.80268 14.7501 4.73287C15.1354 5.66305 15.3337 6.66002 15.3337 7.66684C15.3337 8.67366 15.1354 9.67063 14.7501 10.6008C14.493 11.2214 14.1561 11.8041 13.7489 12.3347L16.7073 15.2931C17.0978 15.6836 17.0978 16.3168 16.7073 16.7073C16.3168 17.0978 15.6836 17.0978 15.2931 16.7073L12.3347 13.7489C11.0031 14.771 9.36395 15.3337 7.66684 15.3337C5.63347 15.3337 3.68338 14.5259 2.24556 13.0881C0.807754 11.6503 0 9.70021 0 7.66684C0 5.63347 0.807754 3.68338 2.24556 2.24556C2.9575 1.53363 3.80268 0.968898 4.73287 0.583603ZM7.66684 2C6.92266 2 6.18577 2.14658 5.49823 2.43136C4.8107 2.71615 4.18599 3.13356 3.65978 3.65978C2.59704 4.72252 2 6.1639 2 7.66684C2 9.16978 2.59704 10.6112 3.65978 11.6739C4.72252 12.7366 6.1639 13.3337 7.66684 13.3337C9.16978 13.3337 10.6112 12.7366 11.6739 11.6739C12.2001 11.1477 12.6175 10.523 12.9023 9.83544C13.1871 9.14791 13.3337 8.41102 13.3337 7.66684C13.3337 6.92266 13.1871 6.18576 12.9023 5.49823C12.6175 4.8107 12.2001 4.18599 11.6739 3.65978C11.1477 3.13356 10.523 2.71615 9.83544 2.43136C9.14791 2.14658 8.41102 2 7.66684 2Z",
    fill: "#1E1E1E",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSearchIcon);
export default __webpack_public_path__ + "static/media/mobile-search-icon.8d8ce3d330604e3b2333dae9f7f63eec.svg";
export { ForwardRef as ReactComponent };